module.exports = __webpack_public_path__ + "img/customers-icon.fd69b530.svg";